import React, { useState, useEffect } from "react";
import axios from "axios";
import '../../styles/GlobalStyles.css'


const Addcredits = () => {

  const [institutes, setInstitutes] = useState([]);
  const [selectedInstitute, setSelectedInstitute] = useState("");
  const [credits, setCredits] = useState("");

  // Fetch institutes on mount
  useEffect(() => {
    const fetchInstitutes = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/institutionfilter/getInstitute`
        );
        setInstitutes(response.data.data || []);
      } catch (error) {
        console.error("Failed to fetch institutes", error);
      }
    };
    fetchInstitutes();
  }, []);



  const handleAddCredits = async () => {
    if (!selectedInstitute) {
      alert("Please select an institute.");
      return;
    }

    const creditValue = Number(credits);
    if (!creditValue || creditValue <= 0) {
      alert("Please enter a valid credit amount.");
      return;
    }

    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}/api/credits/add-credits`,
        {
          userId: selectedInstitute,
          totalcredits: creditValue,
          description: "Admin added credits"
        },
        {
          withCredentials: true,
          headers: {
            "Authorization": `Bearer ${localStorage.getItem("token")}`
          }
        }
      );
      //console.log("credits details ", response.data);
      alert("Credits successfully added.");
      setCredits("");
      setSelectedInstitute("");
    } catch (error) {
      console.error("Error adding credits:", error);
      alert("Failed to add credits. Please try again.");
    }
  };

  return (
    <div className="max-w-4xl px-6 mx-auto">
      <h1 className="mb-6 text-2xl font-semibold">Add Credits</h1>

      {/* Institute Select Dropdown */}
      <div className="max-w-sm mb-6">
        <label htmlFor="instituteSelect" className="block mb-2 font-medium text-gray-700">
          Select Institute
        </label>
        <select
          id="instituteSelect"
          className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
          value={selectedInstitute}
          onChange={(e) => setSelectedInstitute(e.target.value)}
        >
          <option value="">-- Select an Institute --</option>
          {institutes.map((inst) => (
            <option key={inst._id} value={inst._id}>
              {inst.name}
            </option>
          ))}
        </select>
      </div>

      {/* Credits Input */}
      <div className="max-w-sm mb-6">
        <label htmlFor="creditsInput" className="block mb-2 font-medium text-gray-700">
          Enter Credits
        </label>
        <input
          id="creditsInput"
          type="number"
          placeholder="Add credits"
          className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
          value={credits}
          onChange={(e) => setCredits(e.target.value)}
          min="0"
        />
      </div>

      {/* Submit Button */}
      <button
        onClick={handleAddCredits}
        className="px-6 py-2 text-white bg-blue-600 rounded hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
      >
        Add Credits
      </button>
    </div>
  );
};

export default Addcredits;
